import React from "react";

const Dashboard = () => {

    return (
        <div>
            <h3>Dashboard Component</h3>
        </div>
    )
}

export default Dashboard
